import type * as React from "react";

import { LinkButton } from "../Link";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useTranslation } from "react-i18next";

interface ToggleButtonProps {
  isOpen: boolean;
  onToggle: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({ isOpen, onToggle, className }) => {
  const { t } = useTranslation();

  const label = t(`searchPage.refinements.${isOpen ? "showLess" : "showMore"}`);

  return (
    <LinkButton
      onClick={onToggle}
      className={className}
      iconBefore={isOpen ? <KeyboardArrowUpIcon  /> : <KeyboardArrowDownIcon  />}
    >
      {label}
    </LinkButton>
  );
};

export default ToggleButton;
